import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "statusText"]

  declare submitButtonTarget: HTMLButtonElement
  declare statusTextTarget: HTMLElement
  declare hasStatusTextTarget: boolean

  handleSubmit(): void {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Uploading…'

    if (this.hasStatusTextTarget) {
      this.statusTextTarget.hidden = false
    }

    // Fade out the content while the file uploads (network latency provides the delay)
    const content = this.element.querySelector(".voter-list__ai-importer__content") as HTMLElement
    if (content) {
      content.style.transition = "opacity 0.4s ease, transform 0.4s ease"
      content.style.opacity = "0"
      content.style.transform = "scale(0.97)"
    }
  }
}
